import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MutedSpeakerIcon, UnmutedSpeakerIcon } from '@streamr/tv-ui';
import styled from 'styled-components';
import { ViewerService } from '../../services/viewer/ViewerService';
import { Button } from '../Button';
import { Hud } from '../Hud';
export function EmbeddedViewHud({ visible, fullscreenButton, }) {
    const isAudioOnMute = !!ViewerService.getOutput().useAudioMuted();
    return (_jsxs(EmbeddedHud, { visible: visible, children: [_jsx(TopUi, { children: _jsx("div", { children: fullscreenButton }) }), _jsx("div", {}), _jsx(BottomUi, { children: _jsx(Button
                // Used by browser automation to unmute the video
                , { "data-automation-id": "unmute", type: "button", shape: "pill", padding: "none", kind: isAudioOnMute ? undefined : 'secondary', variant: isAudioOnMute ? undefined : 'dark', icon: isAudioOnMute ? (_jsx(MutedSpeakerIcon, {})) : (_jsx(UnmutedSpeakerIcon, {})), onClick: () => {
                        ViewerService.getNotificationInterface().notifyMuteToggle();
                    } }) })] }));
}
const Ui = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem;
`;
const TopUi = styled(Ui) `
    button {
        pointer-events: all;
    }
`;
const BottomUi = styled(Ui) `
    > * {
        pointer-events: all;
    }
`;
const EmbeddedHud = styled(Hud) `
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding: 1.25rem;
    box-sizing: border-box;
`;
